<template>
  <el-row :gutter="10" class="chat-explain">
    <el-col :span="6">
      <div class="grid-content">
        会话时长：<count-timer class="explain-value" ref="sessionTimer" :constContent="curSessionInfo.finalSessTime"></count-timer>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        评价结果：<span class="explain-value">{{ formatEvaluate(curSessionInfo.evaluate) }}</span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        首次响应时间：<span class="explain-value">{{ curSessionInfo.firstResTime ? curSessionInfo.firstResTime.substring(curSessionInfo.firstResTime.lastIndexOf('h') + 1).replace('m', ':').replace('s', '') : '00:00' }}</span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        平均响应时间：<span class="explain-value">{{ curSessionInfo.avgResTime ? curSessionInfo.avgResTime.substring(curSessionInfo.avgResTime.lastIndexOf('h') + 1).replace('m', ':').replace('s', '') : '00:00' }}</span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        咨询业务：<span class="explain-value">{{ curSessionInfo.bizName }}</span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        咨询发起页：
        <span class="explain-value">
          <a :href="curSessionInfo.pageUrl" target="_blank" style="color:#333333;text-decoration:none;"><span style="width: 140px; text-overflow: ellipsis; overflow: hidden; white-space:nowrap;">{{ curSessionInfo.pageName }}</span></a>
        </span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        访客渠道：<span class="explain-value">{{ curSessionInfo.channelName }}</span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        访客地区：<span class="explain-value">{{curSessionInfo.address}}</span>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        参与坐席数：
        <el-dropdown>
          <span class="explain-value link">{{ (curJoinAgent ? curJoinAgent.length : 0) + '人'   }}</span>
          <el-dropdown-menu class="menu-number">
            <el-table tooltip-effect="light" :data="curJoinAgent">
              <!-- <el-table-column :show-overflow-tooltip="true" align="center" prop="skillGroupDTO.name" label="技能组" width="100"></el-table-column> -->
              <el-table-column :show-overflow-tooltip="true" align="center" prop="name" label="坐席" width="160" class="text-dark"></el-table-column>
            </el-table>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        访客昵称：
        <el-tooltip effect="light" :content="visitor_nickname" placement="top-start">
          <span class="explain-value">{{ visitor_nickname }}</span>
        </el-tooltip>
      </div>
    </el-col>
    <el-col :span="6">
      <div class="grid-content">
        访客ID：
        <el-tooltip effect="light" :content="visitor_id" placement="top-start">
          <span class="explain-value">{{ visitor_id }}</span>
        </el-tooltip>
      </div>
    </el-col>

  </el-row>
</template>
<script>
import CountTimer from '@/views/chat/components/CountTimer'

export default {
  components: { CountTimer },
  data() {
    return {}
  },
  props: {
    curSessionInfo: Object,
    curJoinAgent: Array
  },
  watch: {
    curSessionInfo: {
      handler(newVal, oldVal) {
        if (newVal.sessTime !== oldVal.sessTime) {
          this.initSessionInfo(newVal)
        }
      },
      deep: true
    }
  },
  computed: {
    visitor_id: function () {
      return this.$parent.current_user.userId
    },
    visitor_nickname: function () {
      return this.$parent.current_user.body.nickname
    }
  },
  methods: {
    startSessTimer(startTime) {
      this.$refs.sessionTimer.restartTimer(startTime)
    },
    stopSessTimer() {
      this.$refs.sessionTimer.stopTimer()
    },
    initSessionInfo() {
      this.startSessTimer(this.curSessionInfo.sessTime)
    },

    formatEvaluate(evaluate) {
      let evl
      switch (evaluate) {
        case 1:
          evl = '非常满意'
          break
        case 2:
          evl = '满意'
          break
        case 3:
          evl = '一般'
          break
        case 4:
          evl = '不满意'
          break
        case 5:
          evl = '非常不满意'
          break
        default:
          evl = '未评价'
          break
      }
      return evl
    }
  }
}
</script>
<style scoped lang="scss">
.menu-number.el-dropdown-menu {
  width: 170px;
  padding: 0;
  .el-table {
    &:before {
      width: 0;
    }
    ::v-deep th,
    ::v-deep td {
      background-color: #fff !important;
      /*text-align: center;*/
      border-bottom: none !important;
      padding: 4px 15px !important;
      color: #666;
      font-size: 12px;
    }
    ::v-deep td:last-child {
      color: #111 !important;
    }
    ::v-deep .cell {
      width: auto !important;
    }
    ::v-deep .el-table__body-wrapper {
      max-height: 130px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ebebeb;
        border-radius: 2px;
      }
    }
  }
}
</style>
